import React from 'react';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function ExpandCollapseAllButton({ expanded, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            className="tw-flex tw-items-center tw-gap-x-1 tw-text-xs tw-font-medium tw-text-charcoal-50 hover:tw-text-charcoal-75 tw-transition-colors tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer"
        >
            <span>{expanded ? $t('Collapse all') : $t('Expand all')}</span>
            {expanded ? <ChevronUpIcon className="tw-w-3 tw-h-3" /> : <ChevronDownIcon className="tw-w-3 tw-h-3" />}
        </button>
    );
}
